import { McLeodClassicIntegration, Navigation } from "@mcleod/core";
import { AutogenLayoutDirectDepositClassic } from "./autogen/AutogenLayoutDirectDepositClassic";

export class DirectDepositClassic extends AutogenLayoutDirectDepositClassic {

    override onLoad() {
        McLeodClassicIntegration.openClassicScreen("com.tms.client.loadmaster.drs.ParamDrsDirectDeposit", "_");
        Navigation.navigateBack();
    }
}